const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const getUserImageUrl = (imageUrl?: string | null): string | undefined => {
  if (!imageUrl) return undefined;

  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
    return imageUrl;
  }

  const serverBase = API_BASE_URL.replace(/\/api\/?$/, '');
  const path = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;

  return `${serverBase}${path}`;
};
